import React, { useState, useEffect, useCallback } from 'react';
import { getAdminWeddingLogs } from '../services/apiService';

export default function AdminLogsTab() {
  const [logs, setLogs] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [limit] = useState(50);
  const [level, setLevel] = useState(''); // '' | 'info' | 'warn' | 'error'
  const [weddingId, setWeddingId] = useState('all'); // 'all' | 'system' | specific ObjectId
  const [specificIdInput, setSpecificIdInput] = useState('');
  const [loading, setLoading] = useState(false);

  const fetchLogs = useCallback(async () => {
    setLoading(true);
    try {
      const activeWeddingId = weddingId === 'custom' ? specificIdInput.trim() : weddingId;
      
      // Geçersiz ObjectId koruması
      if (weddingId === 'custom' && activeWeddingId.length > 0 && activeWeddingId.length !== 24) {
        setLogs([]);
        setTotal(0);
        setLoading(false);
        return;
      }

      const res = await getAdminWeddingLogs(activeWeddingId || 'all', page, limit, level);
      setLogs(res.logs || []);
      setTotal(res.total || 0);
    } catch (err) {
      console.error("Loglar yüklenirken hata oluştu:", err);
    } finally {
      setLoading(false);
    }
  }, [weddingId, specificIdInput, page, limit, level]);

  useEffect(() => {
    fetchLogs();
  }, [fetchLogs]);

  const handlePageChange = (newPage) => {
    setPage(Math.max(1, newPage));
  };

  const handleWeddingIdTypeChange = (e) => {
    const val = e.target.value;
    setWeddingId(val);
    setPage(1);
  };

  const handleLevelChange = (e) => {
    setLevel(e.target.value);
    setPage(1);
  };

  const totalPages = Math.max(1, Math.ceil(total / limit));

  return (
    <div style={{ marginTop: '20px' }}>
      <div style={{
        display: 'flex',
        gap: '15px',
        alignItems: 'flex-end',
        flexWrap: 'wrap',
        backgroundColor: 'white',
        padding: '15px',
        borderRadius: '10px',
        border: '1px solid #e5e7eb',
        marginBottom: '20px'
      }}>
        {/* Kapsam Filtresi */}
        <div>
          <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: 'bold', marginBottom: '5px' }}>Düğün Kapsamı</label>
          <select value={weddingId} onChange={handleWeddingIdTypeChange} style={{ padding: '8px', borderRadius: '5px', border: '1px solid #ccc' }}>
            <option value="all">Tüm Loglar (Düğün + Sistem)</option>
            <option value="system">Sadece Sistem Logları (Düğün Dışı)</option>
            <option value="custom">Belirli Düğün ID</option>
          </select>
        </div>

        {weddingId === 'custom' && (
          <div>
            <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: 'bold', marginBottom: '5px' }}>Düğün ID (24 Karakter)</label>
            <input
              type="text"
              placeholder="65c2b0..."
              value={specificIdInput}
              onChange={(e) => { setSpecificIdInput(e.target.value); setPage(1); }}
              maxLength={24}
              style={{ padding: '8px', borderRadius: '5px', border: '1px solid #ccc', width: '220px' }}
            />
          </div>
        )}

        {/* Hata Seviyesi */}
        <div>
          <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: 'bold', marginBottom: '5px' }}>Hata Seviyesi</label>
          <select value={level} onChange={handleLevelChange} style={{ padding: '8px', borderRadius: '5px', border: '1px solid #ccc' }}>
            <option value="">Tümü</option>
            <option value="info">Bilgi (INFO)</option>
            <option value="warn">Uyarı (WARN)</option>
            <option value="error">Hata (ERROR)</option>
          </select>
        </div>

        {/* Yenile Butonu */}
        <button 
          onClick={fetchLogs} 
          className="btn" 
          disabled={loading}
          style={{ height: '38px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
          {loading ? 'Yükleniyor...' : '🔄 Yenile'}
        </button>
      </div>

      {loading ? (
        <p>Log günlükleri yükleniyor...</p>
      ) : logs.length === 0 ? (
        <div style={{ padding: '40px', textAlign: 'center', backgroundColor: 'white', borderRadius: '10px', border: '1px solid #e5e7eb', color: '#666' }}>
          Eşleşen herhangi bir günlük kaydı bulunamadı.
        </div>
      ) : (
        <>
          <div className="table-scroll">
            <table className="admin-table" style={{ fontSize: '0.85rem' }}>
              <thead>
                <tr>
                  <th style={{ width: '160px' }}>Tarih</th>
                  <th style={{ width: '100px' }}>Seviye</th>
                  <th style={{ width: '160px' }}>İşlem / Action</th>
                  <th>Düğün ID</th>
                  <th>Mesaj & Detay</th>
                </tr>
              </thead>
              <tbody>
                {logs.map((log) => {
                  let bgColor = 'white';
                  if (log.level === 'error') bgColor = '#fef2f2'; // Hafif kırmızı
                  if (log.level === 'warn') bgColor = '#fffbeb';  // Hafif sarı

                  return (
                    <tr key={log._id} style={{ backgroundColor: bgColor }}>
                      <td style={{ whiteSpace: 'nowrap' }}>
                        {new Date(log.createdAt).toLocaleString('tr-TR')}
                      </td>
                      <td>
                        <span className={`badge ${
                          log.level === 'error' ? 'badge-locked' : log.level === 'warn' ? 'badge-warning' : 'badge-open'
                        }`} style={{ textTransform: 'uppercase', fontSize: '0.75rem', fontWeight: 'bold' }}>
                          {log.level}
                        </span>
                      </td>
                      <td style={{ fontWeight: 'bold' }}>{log.action}</td>
                      <td style={{ fontFamily: 'monospace', fontSize: '0.8rem', color: log.weddingId ? '#333' : '#999' }}>
                        {log.weddingId || 'SİSTEM'}
                      </td>
                      <td>
                        <div style={{ fontWeight: '500' }}>{log.message}</div>
                        {log.metadata && Object.keys(log.metadata).length > 0 && (
                          <pre style={{
                            background: '#f4f5f7',
                            padding: '8px',
                            borderRadius: '5px',
                            marginTop: '6px',
                            overflowX: 'auto',
                            fontSize: '0.75rem',
                            border: '1px solid #e5e7eb',
                            color: '#ef4444' // Hata detaylarını belirgin kırmızı tonlu yapalım
                          }}>
                            {JSON.stringify(log.metadata, null, 2)}
                          </pre>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          {/* Sayfalama */}
          {totalPages > 1 && (
            <div className="pagination-controls" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '15px', marginTop: '20px' }}>
              <button 
                onClick={() => handlePageChange(page - 1)} 
                disabled={page === 1}
                className="btn-outline btn-xs"
              >
                &lt; Önceki
              </button>
              <span style={{ fontSize: '0.9rem', fontWeight: '500' }}>
                Sayfa {page} / {totalPages} (Toplam {total} kayıt)
              </span>
              <button 
                onClick={() => handlePageChange(page + 1)} 
                disabled={page === totalPages}
                className="btn-outline btn-xs"
              >
                Sonraki &gt;
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
}
